module.exports = __webpack_public_path__ + "img/insurance.d233dd88.png";